(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRecordDeleteController',TrainingRecordDeleteController);

    TrainingRecordDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrainingRecord'];

    function TrainingRecordDeleteController($uibModalInstance, entity, TrainingRecord) {
        var vm = this;

        vm.trainingRecord = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrainingRecord.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
